const overflowDocument = (active) => {
  document.documentElement.classList[active ? 'add' : 'remove']('overflow');
};

export default overflowDocument;
